import React, {useEffect, useState} from 'react';
import Slider from "react-slick";
import { Skeleton } from '@mui/material';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './assets/css/LeadCards.css';
import ApiService from "../util/ApiService";

const NextArrow = ({ onClick }) => (
    <button type="button" className="slick-arrow slick-next custom-arrow"  onClick={() =>onClick()} style={{ display: "block" }}>
        <i className="fa fa-chevron-right" aria-hidden="true"></i>
    </button>
);

const PrevArrow = ({ onClick }) => (
    <button type="button" className="slick-arrow slick-prev custom-arrow"  onClick={() =>onClick()} style={{ display: "block" }}>
        <i className="fa fa-chevron-left" aria-hidden="true"></i>
    </button>
);

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

const formatCurrency = (value) => {
    if(!value){
        return '';
    }

    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

const formatHours = (hours) => {
    if(!hours){
        return '';
    }

    return hours.toString().replace('.', ',');
};

const DashboardTopCards = () => {
    const [leadQtde, setLeadQtde] = useState([]);
    const [loading, setLoading] = useState(false);


    const fetchAll= async () => {
        try {
            setLoading(true);

            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}leads/summary`,
                {},
                true
            );


                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);


                setLeadQtde(data || []);

                setLoading(false);

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        fetchAll();
    }, []);



    return (
        <div className="dashboard-top-cards">
            <Slider {...settings}>
                {/* Realizados */}
                <div className="col">
                    <div className="card modern-card dark-card  me-2">
                        <div className="card-body-dashboard  text-center">
                            <div className="dash-widget-icon text-primary">
                                <h5><i className="fa fa-send" aria-hidden="true"></i>
                                </h5>
                            </div>
                            <div className="dash-count">
                                <h3>{loading ? <Skeleton width={50} className="text-center"/> : leadQtde?.sent}</h3>
                            </div>
                            <div className="dash-widget-info">
                                <p>Enviados</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Valor Recebido */}
                <div className="col">
                    <div className="card modern-card dark-card  me-2">
                        <div className="card-body-dashboard text-center">
                            <div className="dash-widget-icon text-success">
                                <h5><i className="fa fa-mouse" aria-hidden="true"></i></h5>
                            </div>
                            <div className="dash-count">
                                <h3>{loading ? <Skeleton width={50} /> : leadQtde?.clicked}</h3>
                            </div>
                            <div className="dash-widget-info">
                                <p>Click</p>
                            </div>
                        </div>
                    </div>
                </div>



                {/* Meu Cadastrados */}
                <div className="col">
                    <div className="card modern-card dark-card me-2">
                        <div className="card-body-dashboard text-center">
                            <div className="dash-widget-icon text-info">
                                <h3><i className="fa fa-clock-o" aria-hidden="true"></i></h3>
                            </div>
                            <div className="dash-count">
                                <h3>{loading ? <Skeleton width={50} /> : leadQtde?.pending}</h3>
                            </div>
                            <div className="dash-widget-info">
                                <p>Pendente</p>
                            </div>
                        </div>
                    </div>
                </div>



            </Slider>
        </div>
    );
};

export default DashboardTopCards;
